import NotificationsController  from "@/js/Webmail/Notifications/NotificationsController";
import IdentitiesHTTPService    from "./HTTP/IdentitiesHTTPService.js";
import IdentitiesHTTPMapping    from "./HTTP/IdentitiesHTTPMapping.js";
import IdentitiesCollectionList from "./Collections/IdentitiesCollectionList.js";
import IdentitiesItem           from "./Collections/IdentitiesItem.js";
import SAPOMailConfig           from "@/SAPOMailConfig.js";

export { IdentitiesControllerSingleton as default };

/**
* Email Identities List Controller
*
* Fetches identities data from the backend server
*
* @author      fheitor <fabio-h-nascimento@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/

class IdentitiesController {
  /**
   * Identities List Options
   *
   * @public
   *
   * @type {IdentitiesCollectionList}
   *
   * @since 7.0.0
   */
  identities = new IdentitiesCollectionList();

  /**
   * Defines if identities were fetched
   *
   * @public
   *
   * @type {CollectionList}
   *
   * @since 7.0.0
   */
  identities_fetched = false;

  /**
   * HTTP Mapping object
   *
   * @private
   *
   * @type {IdentitiesHTTPMapping}
   *
   * @since 7.0.0
   */
  http_mapping = new IdentitiesHTTPMapping();

  /**
   * HTTP Service object
   *
   * @private
   *
   * @type {IdentitiesHTTPMapping}
   *
   * @since 7.0.0
   */
  http_service = new IdentitiesHTTPService();

  /**
   * Fetches identities from the server and stores it on the cache
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async fetchIdentitiesOnce() {
    if (this.indentities_fetched) {
      return true;
    }

    return this.fetchIdentities();
  }

  /**
   * Fetches identities from the server and stores it on the cache
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise<Boolean>}
   */
  async fetchIdentities() {
    let response = await this.http_service.fetch();

    if (response.success === false) {
      NotificationsController.addMessage('notifications.', response.messages);
      return false;
    }

    this.indentities_fetched = true;
    this.http_mapping.map(this.identities, response.results);
    return true
  }


   /**
   * Sets the identities list from a given list
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} identities
   *
   * @return {void}
   */
  setIdentities(identities) {
    this.http_mapping.map(this.identities, identities);
  }

   /**
   * Sets the identity as the default
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IdentitiesItem} identity
   *
   * @return {void}
   */
  async setDefaultIdentity(identity) {
    let response = await this.http_service.setDefault(identity);
    NotificationsController.addMessage('notifications.', response.messages);

    if (response.success === false) {
      return false;
    }

    this.http_mapping.map(this.identities, response.results);
    return true
  }

  /**
   * Saves the identity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IdentitiesItem} identity
   *
   * @return {Promise.<boolean>}
   */
  async saveIdentity(identity, notification = true) {
    let limit = SAPOMailConfig.client.settings.signature.html_size_limit;

    if (identity.signature_html.length > limit) {
      NotificationsController.addError('notifications.editor_html_size_limit', [limit / 1000])
      return false;
    }

    let response = await this.http_service.save(identity);

    if (notification === true) {
      NotificationsController.addMessage('notifications.', response.messages);
    }

    if (response.success === false) {
      return false;
    }

    this.http_mapping.map(this.identities, response.results);
    return true
  }

  /**
   * Deletes an identity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {IdentitiesItem} identity
   *
   * @return {Promise.<boolean>}
   */
  async deleteIdentity( identity ) {
    let response = await this.http_service.delete(identity);
    NotificationsController.addMessage('notifications.', response.messages);

    if (response.success === false) {
      return false;
    }

    this.http_mapping.map(this.identities, response.results);
    return true
  }
}

/**
 * @type {IdentitiesController}
 */
const IdentitiesControllerSingleton = new IdentitiesController();